// extracted by mini-css-extract-plugin
export default {"htmlValue":"htmlValue__1ElrM"};